import { StyleRules, ToolbarClassKey } from '@material-ui/core';

export const MuiToolbar: Partial<StyleRules<ToolbarClassKey, {}>> = {
  dense: {
    minHeight: 56,
  },
};
